import { useState } from "react";
import {
  RequestCreateMstUsersRequest,
  ResponseCreateMstUserResponse,
  UsersApi,
  UsersCreateUserPostRequest,
} from "../../services/OpenAPI";
import { createConfiguration } from "./common";

export const useApiRegisterUser = () => {
  const [resultRegister, setResultRegister] =
    useState<ResponseCreateMstUserResponse>();
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const registerUser = async (user: RequestCreateMstUsersRequest) => {
    setIsLoading(true);
    setError(null);

    try {
      setIsLoading(true);
      const config = createConfiguration();
      const request: UsersCreateUserPostRequest = {
        user,
      };

      const api = new UsersApi(config);
      const response = await api.usersCreateUserPost(request);
      setResultRegister(response);
      return response;
    } catch (err) {
      setError("ユーザー登録に失敗しました");
      console.error(err);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return { registerUser, resultRegister, error, isLoading };
};
